"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignOut = void 0;

var Constants_1 = require("../../Constants");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var Utils_1 = require("../../Utils");

var OperationBase_1 = require("../OperationBase");

var StepTracker_1 = require("../StepTracker");

var framework_1 = require("@xbox/framework");

var Step;

(function (Step) {
  Step["Start"] = "Start";
  Step["ClearXboxTokens"] = "ClearXboxTokens";
  Step["ClearMsaTickets"] = "ClearMsaTickets";
  Step["ClearCookies"] = "ClearCookies";
  Step["Done"] = "Done";
})(Step || (Step = {}));

var SignOut =
/** @class */
function (_super) {
  __extends(SignOut, _super);

  function SignOut(telemetryClient, components, webView, msaUserId) {
    var _this = _super.call(this, telemetryClient) || this;

    _this.components = components;
    _this.webView = webView;
    _this.msaUserId = msaUserId;
    _this.step = new StepTracker_1.StepTracker(ITelemetryClient_1.Area.SignOut, Step.Start);
    Utils_1.assert(!!msaUserId);
    return _this;
  }

  SignOut.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var webViewFlowId, domain, endUrl, startUrl;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Utils_1.assert(this.step.currentStep === Step.Start); // NOXAL:WEB: Have to clear before requesting the MSA redirect for web

            return [4
            /*yield*/
            , this.clearCookiesCallback()];

          case 1:
            // NOXAL:WEB: Have to clear before requesting the MSA redirect for web
            _a.sent();

            webViewFlowId = framework_1.guid();
            domain = this.components.config.msaLoginEndpoint;
            endUrl = this.components.config.msaRedirectUri;
            startUrl = "" + domain + Constants_1.OauthLogoutPath + "?client_id=" + encodeURIComponent(this.components.config.clientId) + "&redirect_uri=" + encodeURIComponent(endUrl) + "&state=" + webViewFlowId;
            Utils_1.assert(this.step.currentStep === Step.ClearMsaTickets);
            this.step.advance(Step.ClearCookies);
            return [4
            /*yield*/
            , this.webView.showUrl(startUrl, endUrl, true, // suppressUi
            webViewFlowId, new Map())];

          case 2:
            _a.sent();

            this.step.advance(Step.Done);
            this.succeed(undefined);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  SignOut.prototype.clearCookiesCallback = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            Utils_1.assert(this.step.currentStep === Step.Start); // Clear U and X tokens associated with this user

            this.step.advance(Step.ClearXboxTokens);
            return [4
            /*yield*/
            , this.components.xboxCache.clearTokensForUser(this.msaUserId)];

          case 1:
            _a.sent();

            Utils_1.assert(this.step.currentStep === Step.ClearXboxTokens); // Clear MSA credentials

            this.step.advance(Step.ClearMsaTickets);
            return [4
            /*yield*/
            , this.components.msaCache.clearTokensForUser(this.msaUserId)];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return SignOut;
}(OperationBase_1.OperationBase);

exports.SignOut = SignOut;